module.exports = __webpack_public_path__ + "img/sprites.9c195b15.png";